function handleSbs( sbsProps ) {

    // console.log( sbsProps );

    let mediaUrl = "placeholder";

    if( sbsProps.media ) {
        mediaUrl = sbsProps.media.url;
    }


    window.top.postMessage(
    
        JSON.stringify( {

            actionType: 'SET_SURVEY_PAGE',
            imgUrl: mediaUrl,
            hideMediaView: sbsProps.hideMediaView,
            hotspots: sbsProps.hotspots,
            autoContinue: sbsProps.autoContinue,

        }),
        '*'
    )

}

function listenForSbsEvents( app, cb ) {

    window.onmessage = function(e) {

        // console.log( e );
        
        if( !e.data || e.data === "" ) return;

        let data;
        try {
            data = JSON.parse( e.data );
        } catch (error) {
            return;
        }

        if( data.actionType === 'HOTSPOT_CLICK' ) {

            const pos = app.state.pos;
            const stepData = app.state.steps[pos];
            const currentStepKey = stepData.qKey;
            const resultKey = currentStepKey + "_sbs_hotspot";
            global.setAnswer( resultKey , data.key );

            app.setState( {allowNext: true})

            if( data.autoContinue ) {
                global.nextStage(stepData.followingScreen);
            }
		}

    
    }
}

export { handleSbs, listenForSbsEvents };


// WEBPACK FOOTER //
// ./src/SBSmanager.js